"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleCover = void 0;
var moduleCover_1 = require("./moduleCover");
Object.defineProperty(exports, "ModuleCover", { enumerable: true, get: function () { return __importDefault(moduleCover_1).default; } });
